import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { EditIcon, EyeSvg } from "assets/images/common/svgs";
import { siteRoutes } from "utils/helpers/enums/routes.enum";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";

import editProfileUSer from "assets/images/common/others/editProfileUSer.png";
import { confirmationPopup } from "utils/helpers/common/alert-service";
import useProductItem from "containers/master-portal/useHooks";
import useStore from "hooks/useStore";
import { sitePermissions } from "utils/helpers/enums/permissions.enum";

const ProductItems: React.FC = () => {
  const { hasPermission } = useStore();
  const navigate = useNavigate();
  const [data, setData] = useState<any[]>([]);
  const { getProductItems, updateProductItemStatus } = useProductItem();
  useEffect(() => {
    const fetchData = async () => {
      await getProductItems(setData, {});
    };
    fetchData();
  }, []);

  const handleChangeStatus = async (user: any, index: number) => {
    const userId = user.id;
    const currentStatus = user.status;
    const newStatus = !currentStatus;
    const actionText = currentStatus ? "Deactivate" : "Activate";
    const result = await confirmationPopup(
      `Are you sure you want to ${actionText} this status?`
    );

    if (result.isConfirmed) {
      await updateProductItemStatus(userId, { status: newStatus });
      await getProductItems(setData, {});
    }
  };

  console.log(data);

  return (
    <div className="pb-6">
      <h1 className="text-2xl sm:text-[32px] text-primaryText font-bold">
        Product Items
      </h1>

      <div className="flex justify-between items-center gap-5 my-6">
        {hasPermission(sitePermissions.productItemsCreate) && (
          <button
            onClick={() => navigate(siteRoutes.productItemsCreate)}
            className="px-4 py-2 text-sm bg-goldenOrangeBg text-white rounded-lg font-semibold"
          >
            Add New Item
          </button>
        )}
      </div>

      <div className="bg-white p-6 rounded-lg">
        <div className="grid grid-cols-1  md:grid-cols-2 lg:grid-cols-3 gap-6">
          {data.map((item: any, index: number) => (
            <div
              key={index + 1}
              className="bg-dividerLightBg relative  border border-stokeLight rounded-[30px] p-6 flex flex-col items-center justify-center gap-2 text-center h-fit"
            >
              {hasPermission(sitePermissions.productItemsUpdate) ? (
                <span
                  onClick={() => {
                    navigate(`${siteRoutes.productItemEdit}?id=${item.id}`);
                  }}
                  className="bg-goldenOrangeBg cursor-pointer p-2 rounded-md absolute top-5 right-5"
                >
                  <EditIcon className="w-4 h-4" />
                </span>
              ) : (
                <span className="bg-goldenOrangeBg cursor-not-allowed p-2 rounded-md absolute top-5 right-5">
                  <EditIcon className="w-4 h-4" />
                </span>
              )}

              <div className="relative mt-5">
                <img
                  src={
                    item?.image?.name
                      ? concatPathWithBackendUrl(item?.image?.name)
                      : editProfileUSer
                  }
                  alt={item?.name}
                  className="w-[157px] h-[177px] mt-4"
                />
              </div>

              <h3 className="text-primaryText text-2xl font-bold">
                {item?.itemName}
              </h3>

              <span className="text-base text-primaryText flex gap-2">
                {item?.cost ? `Cost ${item?.cost} pts` : ""}
              </span>
              <p className="text-primaryText">
                Delivery Fee:{" "}
                <span className="text-goldenAmberText">
                  {item?.deliveryFee > 0 ? `${item?.deliveryFee} pts` : "Free"}
                </span>
              </p>

              <span>
                {hasPermission(sitePermissions.productItemsUpdate) ? (
                  <label className="switch-field">
                    <input
                      type="checkbox"
                      checked={item?.status}
                      onChange={() => handleChangeStatus(item, index)}
                    />
                    <span className="slider"></span>
                  </label>
                ) : (
                  <label className="switch-field cursor-not-allowed opacity-60">
                    <input type="checkbox" checked={item?.status} disabled />
                    <span className="slider slider-disabled"></span>
                  </label>
                )}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductItems;
